<template>
  <div class="within-school-main">
    <el-table ref="refTable"  @row-click="expandRow" style="width: 100%" :data="data" :row-class-name="rowClassName">
      <el-table-column type="expand" >
        <template slot-scope="{row}">
          <el-form label-position="left"  label-width="110px" class="demo-table-expand" style="margin-left: 10px">
            <el-form-item label="文章标题" >
              <div class="axj-show-club-main-content">
                {{row.title}}
              </div>
            </el-form-item>
            <el-form-item style="margin-top: -20px"  label="发布时间" >
              {{ row.created_at|parseTime}}
            </el-form-item>
            <el-form-item label="标签" style="margin-top: -20px">
              <el-tag size="mini" :key="x.Tag.value" style="margin-right: 10px" type="info" v-for="x in row.Tags">#{{x.Tag.name}}</el-tag>
            </el-form-item>
            <el-form-item style="margin-top: -20px" label="浏览" >
              {{ row.read_sum }}
            </el-form-item>
            <el-form-item style="margin-top: -20px" label="点赞" >
              {{ row.like_sum }}
            </el-form-item>
            <el-form-item style="margin-top: -20px" label="评论" >
              {{row.comment_sum}}
            </el-form-item>
            <el-form-item style="margin-top: -20px" label="转发" >
              {{ row.share_sum }}
            </el-form-item>
            <el-form-item style="margin-top: -20px;" label="封面" >
              <div class="axj-show-club-main-images" v-if="row.cover_type==0&&row.thumb1!=''">
<!--                <div class="axj-show-club-main-image" >-->
<!--                  <el-image-->
<!--                    :src="preViewUrl+'/'+row.thumb1"-->
<!--                    lazy-->
<!--                    :preview-src-list=",row.thumb1|arrayImg"-->
<!--                  >-->
<!--                  </el-image>-->
<!--                </div>-->

                <div :class="'post-main-word'" >
                  <ul @click="previewWord({type:'image',url:row.thumb1})" class="el-upload-list el-upload-list--text">
                    <li tabindex="0" class="el-upload-list__item is-success">
                      <a class="el-upload-list__item-name">
                        <i class="el-icon-document"></i>
                        文件
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </el-form-item>
            <el-form-item style="margin-top: -20px;" label="文章内容" >
              <div class="axj-show-club-main-content" v-html="row.content">
              </div>
            </el-form-item>

          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="发布时间"  width="160px" prop="time">
        <template slot-scope="{row}">
          {{ row.created_at|parseTime}}
        </template>
      </el-table-column>
      <el-table-column label="文章标题" show-overflow-tooltip  prop="title"></el-table-column>
      <el-table-column label="点赞"  width="80px" prop="doSearch">
        <template slot-scope="{row}">
          {{ row.like_sum }}
        </template>
      </el-table-column>
      <el-table-column label="评论"  width="80px" prop="doSearch">
        <template slot-scope="{row}">
          {{row.comment_sum}}
        </template>
      </el-table-column>
      <el-table-column label="转发"  width="80px" prop="doSearch">
        <template slot-scope="{row}">
          {{ row.share_sum }}
        </template>
      </el-table-column>
      <el-table-column  width="115px" label="操作">
        <template slot-scope="{row}">
          <axj-button-v2
            button-color="bread"
            button-size="medium"
            button-icon="del1"
          ></axj-button-v2>
          <axj-button-v2
            @click="handleUpdate(row.id)"
            button-icon="edit1"

          ></axj-button-v2>
        </template>
      </el-table-column>
    </el-table>
    <axj-file-preview
      :show-preview.sync="preview.show"
      :preview-file-type="preview.previewFileType"
      :preview-files="preview.previewFiles"
    />
  </div>
</template>

<script>
import AxjButtonV2 from "../../../../../components/common/button/axj-button";
import AxjButton from "../../../../../components/axj-button/index";
import commonModels from '@/common/models/common-models'
import common from '@/common/common'
export default {
  name: "within-school-main",
  components: {AxjButtonV2, AxjButton},
  props:{
    data:{
      type:Array,
      default:()=>{
        return []
      }
    }
  },
  watch:{
    data(v){

    }
  },
  methods:{
    previewWord(x){
      this.preview.previewFileType=x.type
      this.preview.previewFiles=[]
      this.preview.previewFiles.push({
        url:x.url
      })
      this.preview.show=true
    },
    handlePlayVideo(row) {
      if(row.video_url) {
        let url = row.video_url.indexOf('http')>=0?row.video_url:this.resourcePrefix.url+row.video_url
        this.video.url = url
        this.showLovePlayer = true
      }
    },
    handleUpdate(v){
      this.$emit('update',v)
    },
    expandRow(row,index,e){
      let target=e.target
      if(target.className.indexOf('cell')==0||target.className.indexOf('el-tag')==0||target.className.indexOf('el-table')==0){
        this.$refs.refTable.toggleRowExpansion(row)
        return
      }
    },
    rowClassName({row, rowIndex}){
      row.index=rowIndex
      if(rowIndex%2==0){
        return "while-row"
      }else{
        return "gray-row"
      }
    }
  },
  computed:{
    preViewUrl(){
      return this.$common.SystemConfig.PreViewUrl
    }
  },
  filters:{
    parseTime(time){
      return commonModels.formatTime(time,'Y/M/D h:m:s')
    },
    arrayImg(v,x){
      let preViewUrl=common.SystemConfig.PreViewUrl
      let array=[]
      array.push(
        preViewUrl+x
      )
      // for (let i =0 ;i<v.length;i++){
      //   if(v[i].url===x.url){
      //     let temp=array[0]
      //     array[0]=preViewUrl+x.url
      //     array.push(temp)
      //   }else{
      //     array.push(preViewUrl+v[i].url)
      //   }
      //
      // }
      return array
    }
  },
  data(){
    return{
      preview:{
        show:false,
        previewFileType:'word',
        previewFiles:[]
      },
      showLovePlayer: false,
      video: {
        url : '',
      },
    }
  }
}
</script>

<style scoped lang="scss">
.within-school-main{
  .el-tag,.el-tag--info {
    background-color: #41555d;
    /* border-color: #e9e9eb; */
    color: #ffffff;
  }
  .el-table__body tr:hover>td{
    background-color: #f2f5f8 !important;
  }
  .el-table__body tr.current-row>td{
    background-color: #f2f5f8 !important;
  }
  .axj-show-club-main-content{
    line-height: 20px;
    margin-top: 9px;
  }
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .while-row {
    background: #ffffff;
  }
  .el-table .gray-row {
    background: #e8eef0;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-table .info-row{
    background: #D6D8DC;
  }
  .axj-show-club-main-images{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .axj-show-club-main-dio{
      width: 126.888px;
      height: 126.888px;
      border-radius: 10px;
      margin-top: 18.26px;
      img{
        width: 100%;
        height: 100%;
        width: 126.888px;
        height: 126.888px;
        border-radius: 10px;
      }
    }
    .post-main-word{
      width: 426.888px;
      height: 26.888px;
      border-radius: 10px;
      margin-top: 18.26px;
    }
    .axj-show-club-main-image{
      width: 126.888px;
      height: 126.888px;
      border-radius: 10px;
      margin-top: 18.26px;
      .el-image{
        width: 100%;
        height: 100%;
        width: 126.888px;
        height: 126.888px;
        border-radius: 10px;
      }
    }
    .axj-show-club-main-image:not(:first-child){
      margin-left: 30.5px;
    }
    .axj-show-club-main-image:nth-child(5n+6){
      margin-left: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-within-school/component/within-school-main/index.vue